@if (client) {
<div>
  <div
    [routerLink]="['clients']"
    [queryParams]="{ taxYear: year }"
    id="route-name"
    title="Back to clients"
  >
    {{ "clients" | transloco }}
  </div>
  <h2
    (click)="userInfo.isClientAdmin && showClientEditModal()"
    id="client-name"
    title="{{ userInfo.isClientAdmin ? 'Edit client name' : undefined }}"
    [ngClass]="{ editable: userInfo.isClientAdmin }"
  >
    {{ client?.name }}
    @if (userInfo.isClientAdmin) {
    <div class="edit icon"></div>
    }
  </h2>
  <div id="tax-year">
    @if (taxYearOptions) {
    <app-search-dropdown
      label="{{ yearLabel }}"
      [formGroup]="searchForm"
      [formCtrl]="taxYear"
      [listOptions]="taxYearOptions"
    ></app-search-dropdown>
    }
  </div>
  <div class="secondary-sub-menu ui list">
    <div
      (click)="setCurrentView(getClientSidebarEnum().POPULATIONS)"
      [routerLink]="['clients', client?.id, 'populations']"
      [class.active]="isCurrentView(getClientSidebarEnum().POPULATIONS)"
      [queryParams]="{ taxYear: year }"
      class="item"
    >
      {{ "populations" | transloco }}
    </div>
    <div
      (click)="setCurrentView(getClientSidebarEnum().ALL_TAXPAYERS)"
      class="item"
      [routerLink]="['clients', client?.id, uiConfig.config.taxpayerAliasPath]"
      [class.active]="isCurrentView(getClientSidebarEnum().ALL_TAXPAYERS)"
      [queryParams]="{ taxYear: year, clientId: client?.id }"
    >
      {{ 'all-tax-return-alias-s-for-this-client' | transloco: {taxReturnAlias} }}
    </div>
    <div
      (click)="setCurrentView(getClientSidebarEnum().UPLOAD_SOURCE)"
      [routerLink]="['clients', client?.id, 'dynamic-sources-dropdown']"
      [class.active]="isCurrentView(getClientSidebarEnum().UPLOAD_SOURCE)"
      [queryParams]="{ taxYear: year, clientId: client?.id }"
      class="item"
    >
      {{ "upload-source" | transloco }}
    </div>
  </div>
  @if ( currentBatch && currentBatch.name && (batchSelected ||
  viewWarningsClicked || viewOverridesClicked) ) {
  <div class="current__batch">
    <div class="batch-name editable" (click)="showBatchEditModal()">
      <h5 class="batch ">
        {{ "batch" | transloco }} {{ currentBatch.name }}
        <div class="edit icon"></div>
      </h5>
    </div>
    @if (currentBatch.batchPackageLocation) {
    <a target="_blank" [href]="currentBatch.batchPackageLocation | KExplorer">{{
      "view-documents" | transloco
    }}</a>
    } @if (!currentBatch.batchPackageLocation) {
    <a title="No documents generated">{{ "view-documents" | transloco }}</a>
    }
    <br />
    <br />
    @if (!gettingWarningsCount && currentBatch) {
    <div [class.active]="true">
      <span
        (click)="onClickViewWarnings()"
        [routerLink]="[
          'clients',
          client?.id,
          'batch-warnings',
          currentBatch.id
        ]"
        class="item"
        >{{ "view-warnings" | transloco }} (
        {{ batchWarnings.count || 0 }} )</span
      >
      <i class="sync icon" (click)="refreshGetWarningsCount()"></i>
    </div>
    } @if (gettingWarningsCount) {
    <div class="item">
      {{ "view-warnings" | transloco }} ( {{ batchWarnings.count }} -
      {{ batchWarnings.pct }}% <span class="ui active inline loader"></span>)
    </div>
    }
    <div class="item">
      <span
        (click)="onClickViewOverrides()"
        [routerLink]="[
          'clients',
          client?.id,
          'batch-overrides',
          currentBatch.id
        ]"
        class="item"
      >
        {{ "view-overrides" | transloco }} ( {{ batchOverrides.count }} )
      </span>
    </div>
  </div>
  } @if ( isCurrentView(getClientSidebarEnum().ALL_TAXPAYERS) &&
  processNames.length ) {
  <div class="batch__generation">
    <p class="title">{{ "generating-status" | transloco }}</p>
    <div class="generate-messages">
      @for (generationMessage of generationMessages; track generationMessage;
      let i = $index) {
      <div [attr.data-index]="i">
        @if (processNames[i]) {
        <p [innerHtml]="processNames[i]" class="title"></p>
        } @if (generationMessages[i]) {
        <p [innerHtml]="generationMessages[i]" class="message"></p>
        } @if (showPackageLink[i] && packageDates[i]) {
        <p [innerHtml]="packageDates[i]" class="message-dates"></p>
        } @if (batchWithPackageLocation[i] && showDownLoadPackageButton) {
        <button
          (click)="downloadPackage(batchWithPackageLocation[i])"
          [disabled]="!showPackageLink[i]"
          class="ui button basic primary download-button"
        >
          Download Package
        </button>
        }
      </div>
      }
    </div>
  </div>
  } @if ( currentBatch && currentBatch.name && batchSelected &&
  isCurrentView(getClientSidebarEnum().ALL_TAXPAYERS) &&
  batchCalcsMessages.length && batchCalcsprocessNames.length ) {
  <div class="batch__calcs">
    <p class="title">{{ "batchCalcs-status" | transloco }}</p>
    <div class="generate-messages">
      @for (generationMessage of batchCalcsMessages; track generationMessage;
      let i = $index) {
      <div [attr.data-index]="i">
        @if (batchCalcsprocessNames[i]) {
        <p [innerHtml]="batchCalcsprocessNames[i]" class="title"></p>
        } @if (batchCalcsMessages[i]) {
        <p [innerHtml]="batchCalcsMessages[i]" class="message"></p>
        }
      </div>
      }
    </div>
  </div>
  }
  <!--  <div *ngIf="currentBatch && currentBatch.batchPackageLocation && showDownLoadPackageButton" class="item">-->
  <!--    <button-->
  <!--      (click) = "downloadPackage()"-->
  <!--      class="ui button basic primary ">-->
  <!--      Download Package-->
  <!--    </button>-->
  <!--  </div>-->
</div>
} @if (userInfo.isClientAdmin) {
<div>
  <div #editClientModal id="edit-client-modal" class="ui modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "edit-client" | transloco }}</h1>
    <form (ngSubmit)="saveClient()">
      <div class="content">
        <label>{{ "client-name" | transloco }}</label>
        @if (client) {
        <input
          id="edit-client-name-input"
          type="text"
          name="name"
          [(ngModel)]="editedClientName"
        />
        } @if (config.featureFlags.clientDigitalGatewayIdentifier) {
        <label>Client Digital Gateway Identifier</label>
        } @if (client && config.featureFlags.clientDigitalGatewayIdentifier) {
        <input
          id="edit-client-digital-gateway-identifier-input"
          type="number"
          min="0"
          max="1999999999"
          name="digitalGatewayIdentifier"
          [(ngModel)]="editedClientDigitalGatewayIdentifier"
        />
        } @if (!validateDigitalGatewayIdentifier()) {
        <div id="notValidDGI" class="error-message">
          {{ validateDGIText }}
        </div>
        }
      </div>
      <div class="actions">
        <div>
          @if (canDelete()) {
          <div (click)="confirmDelete()" id="delete" title="Delete this client">
            {{ "delete-client" | transloco }}
          </div>
          } @if (!canDelete()) {
          <div id="no-delete">
            {{ deleteTxt }}
          </div>
          }
        </div>
        <span class="go-back cancel">{{ "cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [disabled]="!editedClientName"
        >
          {{ "save" | transloco }}
        </button>
      </div>
    </form>
  </div>
  <div #confirmDeleteClient id="confirm-delete-client" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "are-you-sure" | transloco }}</h1>
    <div class="content">
      {{ "are-you-sure-you-would-like-to-delete-this-client" | transloco }}
    </div>
    <div class="actions">
      <span class="go-back cancel">{{ "cancel" | transloco }}</span>
      <button class="ui primary background approve button">
        {{ "yes-delete" | transloco }}
      </button>
    </div>
  </div>
</div>
}

<div #editBatchNameModal id="edit-batch-modal" class="ui modal">
  <div class="icon modal-close close"></div>

  <h1>{{ "edit-batch-name" | transloco }}</h1>

  <form (ngSubmit)="saveBatchName()">
    <div class="content">
      <label>{{ "batch-name" | transloco }}</label>
      @if (client) {
      <input
        id="edit-batch-name-input"
        type="text"
        name="name"
        [(ngModel)]="editedBatchName"
      />
      }
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "cancel" | transloco }}</span>
      <button
        class="ui primary background button"
        [disabled]="!editedBatchName"
      >
        {{ "save" | transloco }}
      </button>
    </div>
  </form>
</div>
